window.actualizarModalReporteSoplado = null;

if (window.location.pathname === "/soplado/periodo" || window.location.pathname === "/zona-trabajo") {

    let _obsUsuarioModificado = false;

    document.addEventListener('input', function(e) {
        if (e.target && e.target.id === 'observacionesSoplado') {
            _obsUsuarioModificado = true;
        }
    });

    document.addEventListener('reset', function(e) {
        if (e.target && e.target.id === 'formProduccionSoplado') {
            _obsUsuarioModificado = false;
        }
    });

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    // ─── Helpers de formato ──────────────────────────────────────────────────────
    const num          = n => (Number(n) || 0).toLocaleString('en-US');
    const numInput     = n => (Number(n) || "") === "" ? "" : (Number(n)).toLocaleString('en-US');
    const numberFormat = n => (n === null || n === "" || isNaN(n)) ? "-" : new Intl.NumberFormat('en-US').format(n);
    const numberDecimal= n => (n === null || n === "" || isNaN(n)) ? "-" : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
    const fecha        = f => f ? String(f).split('-').reverse().join('/') : '-';
    const txt          = t => String(t ?? '').trim();
    const formatText   = s => (!s || s.trim() === "") ? "-" : String(s);
    const hora         = h24 => {
        if (!h24) return '-';
        let [h, m] = String(h24).split(':');
        if (!h || !m) return '-';
        return `${h % 12 || 12}:${m} ${h < 12 ? 'a.m.' : 'p.m.'}`;
    };

    // ─── Helper: set value o textContent según tipo de elemento ─────────────────
    const set = (id, value) => {
        const el = document.getElementById(id);
        if (!el) return;
        if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') el.value = value;
        else el.textContent = value;
    };

    // ─── Helpers: mostrar / ocultar ──────────────────────────────────────────────
    const mostrar  = id => { const el = document.getElementById(id); if (el) el.style.display = ''; };
    const ocultar  = id => { const el = document.getElementById(id); if (el) el.style.display = 'none'; };
    const mostrarEl= el => { if (el) el.style.display = ''; };
    const ocultarEl= el => { if (el) el.style.display = 'none'; };

    // ─── Helper: fila sin datos ──────────────────────────────────────────────────
    const filaSinDatos = (colspan, texto) => `
        <tr class="no-data">
            <td colspan="${colspan}">
                <div class="cont-no-data">
                    <img class="icono-pequeño-gris" src="/public/build/img/icons/informacion.svg" alt="">
                    ${texto}
                </div>
            </td>
        </tr>`;

    // ─── Helper: renderizar tbody de lotes ───────────────────────────────────────
    const renderLotes = (tbodyId, lotes, clasesTr, dataModal, descripcionMaterial) => {
        const tbody = document.getElementById(tbodyId);
        if (!tbody) return;
        if (lotes.length === 0) {
            tbody.innerHTML = filaSinDatos(4, 'No hay registros de lotes.');
            return;
        }
        tbody.innerHTML = lotes.map((lote, idx) => `
            <tr data-modal="${dataModal}"
                data-id="${lote.idLineaLotePreformaSoplado}"
                data-id-materia-prima="${lote.idPreforma}"
                data-material="${descripcionMaterial}"
                class="trSelect ${clasesTr} btnModal">
                <td>${idx + 1}</td>
                <td>${lote.numeroLote}</td>
                <td>${hora(lote.horaInicio)}</td>
                <td>${hora(lote.horaFin)}</td>
            </tr>`).join('');
    };

    // ─── Función principal ────────────────────────────────────────────────────────
    window.actualizarModalReporteSoplado = (id) => {
        const modal = document.querySelector("#modalProduccionSoplado");
        const pestañaActiva = modal.querySelector(".etiquetaSelect");
        const idEtiquetaGuardada = pestañaActiva ? pestañaActiva.getAttribute("data-etiqueda") : "cabecera";

        const inputIdActual = document.getElementById('idReporteSoplado');
        const idActual = inputIdActual ? inputIdActual.value : '';
        if (String(id) !== String(idActual)) {
            _obsUsuarioModificado = false;
        }

        const url = `/api/soplado/infoReporte?IdReporteSoplado=${id}`;

        fetch(url, requestOptions)
            .then(response => {
                if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
                return response.json();
            })
            .then(result => {
                const data = result.result;
                const { infoUsuario, encabezado, preforma, lotesPreforma, produccionSoplado, pncSoplado, tiempoMuerto, entrega, perfilOperativo } = data;
                const estado = encabezado.estado;
                const rolUsuario = infoUsuario ? infoUsuario.idRol : null;
                const hayRegistros = produccionSoplado.length > 0 || pncSoplado.length > 0
                    || tiempoMuerto.length > 0 || lotesPreforma.length > 0;

                // ── Título ───────────────────────────────────────────────────────
                set('tituloModalSoplado',
                    `ID ${encabezado.idReporteSoplado} - Reporte de producción soplado - ${fecha(encabezado.fechaCreacionTurnoSoplado)} - ${encabezado.nombreTurno}`
                );

                // ── Hidden input ─────────────────────────────────────────────────
                set('idReporteSoplado', encabezado.idReporteSoplado);

                // ── Botones de acción (mostrar según estado y rol) ───────────────
                const btnFinalizar = document.getElementById('btnModalFinalizarReporteSoplado');
                const btnEliminar  = document.getElementById('btnEliminarReporteSoplado');
                const btnReactivar = document.getElementById('btnReactivarReporteSoplado');

                ocultarEl(btnFinalizar);
                ocultarEl(btnEliminar);
                ocultarEl(btnReactivar);

                if (estado == 1) {
                    mostrarEl(btnFinalizar);
                }
                if (estado == 1 && rolUsuario == 1) {
                    btnEliminar.setAttribute('data-id', encabezado.idReporteSoplado);
                    btnEliminar.setAttribute('data-tiene-registros', hayRegistros ? '1' : '0');
                    mostrarEl(btnEliminar);
                }
                if (estado == 2 && rolUsuario == 1) {
                    btnReactivar.setAttribute('data-id', encabezado.idReporteSoplado);
                    mostrarEl(btnReactivar);
                }

                // ── Cabecera: imágenes y nombres ─────────────────────────────────
                const imgMecanico  = document.getElementById('fotoMecanicoSoplado');
                const imgOperario  = document.getElementById('fotoOperarioSoplado');
                const imgEmpacador = document.getElementById('fotoEmpacadorSoplado');
                const nombreEmpacador = encabezado.nombreEmpacador ? encabezado.nombreEmpacador : 'NO ASIGANDO';
                if (imgMecanico)  imgMecanico.src  = `/public/uploads/usuarios/${encabezado.fotoMecanico}?v=${Date.now()}`;
                if (imgOperario)  imgOperario.src  = `/public/uploads/usuarios/${encabezado.fotoOperario}?v=${Date.now()}`;
                if (imgEmpacador) imgEmpacador.src = encabezado.fotoEmpacador
                    ? `/public/uploads/usuarios/${encabezado.fotoEmpacador}?v=${Date.now()}`
                    : `/public/build/img/icons/caja.png`;

                set('nombreMecanicoSoplado',  encabezado.nombreMecanico);
                set('nombreOperarioSoplado',  encabezado.nombreOperario);
                set('nombreEmpacadorSoplado', nombreEmpacador);

                // ── Cabecera: inputs de info ─────────────────────────────────────
                set('fechaCreacionTurnoSoplado', encabezado.fechaCreacionTurnoSoplado);
                set('idZonaSoplado',         encabezado.zonasTrabajo);
                set('idTurnoSoplado',        encabezado.nombreTurno);
                set('idMaquinaSoplado',      encabezado.nombreMaquina);
                set('numOfSoplado',          encabezado.numOf);
                set('idReferenciaSoplado',   encabezado.codigoSap);
                set('descReferenciaSoplado', encabezado.DescripSap);
                set('cicloSoplado',          encabezado.cicloSegundos);
                set('cavMoldeSoplado',       encabezado.cavMolde);
                set('cavActivasSoplado',     encabezado.cavActivas);
                set('undHoraSoplado',        numberFormat(encabezado.undHora));

                // ── Composición: canvaBloqueado ──────────────────────────────────
                const contComp = document.getElementById('contComposicionProducto');
                if (contComp) contComp.classList.toggle('canvaBloqueado', estado != 1);

                // ── Preforma (tabla de lotes) ─────────────────────────────────────
                if (preforma && preforma.idPreforma) {
                    mostrar('seccionMtPrima1Soplado');
                    set('idMateriaPrima1Soplado',     preforma.idPreforma);
                    set('codigoMtPrima1Soplado',      preforma.codigoSap);
                    set('descripcionMtPrima1Soplado', preforma.descripSap);
                    set('porMtPrima1Soplado',         num(preforma.peso));
                    estado == 1 ? mostrar('btnModalAgregarLoteMateriaPrimaSoplado')
                                : ocultar('btnModalAgregarLoteMateriaPrimaSoplado');
                    renderLotes('tbodyLotesMtPrima1Soplado', lotesPreforma,
                        'trSelectLoteMateriaPrimaSoplado', 'modalEditarLoteMateriaPrimaSoplado',
                        preforma.descripSap);
                } else {
                    ocultar('seccionMtPrima1Soplado');
                }

                // ── Reporte producción ───────────────────────────────────────────
                estado == 1 ? mostrar('btnAgregarProduccionSoplado')
                            : ocultar('btnAgregarProduccionSoplado');

                const tbodyProduccion = document.getElementById('tbodyProduccionSoplado');
                if (tbodyProduccion) {
                    tbodyProduccion.innerHTML = produccionSoplado.length === 0
                        ? filaSinDatos(4, 'No hay registros de producción para este turno.')
                        : produccionSoplado.map(p => `
                            <tr data-modal="modalEditarProduccionSoplado"
                                data-id="${p.idLineaProduccionSoplado}"
                                class="trSelect trSelectProduccionSoplado btnModal">
                                <td>${hora(p.horaInicio)}</td>
                                <td>${hora(p.horaFin)}</td>
                                <td>${numberFormat(p.tiempoProductivo)}</td>
                                <td>${numberFormat(p.undsBuenas)}</td>
                            </tr>`).join('');
                }

                // ── Tiempos muertos ──────────────────────────────────────────────
                estado == 1 ? mostrar('btnAgregarTiempoMuertoSoplado')
                            : ocultar('btnAgregarTiempoMuertoSoplado');

                const tbodyTiempo = document.getElementById('tbodyTiempoMuertoSoplado');
                if (tbodyTiempo) {
                    tbodyTiempo.innerHTML = tiempoMuerto.length === 0
                        ? filaSinDatos(4, 'No hay registros de tiempo muerto para este turno.')
                        : tiempoMuerto.map(t => `
                            <tr data-modal="modalEditarTiempoMuertoSoplado"
                                data-id="${t.idLineaTiempoMuertoSoplado}"
                                class="trSelect trSelectTiempoMuerto btnModal">
                                <td>${hora(t.horaInicio)}</td>
                                <td>${hora(t.horaFin)}</td>
                                <td>${numberFormat(t.minTiempoMuerto)}</td>
                                <td>${formatText(t.nombreCausaTiempoMuerto)}</td>
                            </tr>`).join('');
                }

                // ── Producto no conforme ─────────────────────────────────────────
                estado == 1 ? mostrar('btnAgregarPncSoplado')
                            : ocultar('btnAgregarPncSoplado');

                const tbodyPnc = document.getElementById('tbodyPncSoplado');
                if (tbodyPnc) {
                    tbodyPnc.innerHTML = pncSoplado.length === 0
                        ? filaSinDatos(8, 'No hay registros de producto no conforme para este turno.')
                        : pncSoplado.map(p => `
                            <tr data-modal="modalEditarPncSoplado"
                                data-id="${p.idLineaPncSoplado}"
                                class="trSelect trSelectPncSoplado btnModal">
                                <td>${hora(p.horaInicio)}</td>
                                <td>${hora(p.horaFin)}</td>
                                <td>${formatText(p.nombreDefectoPreforma)}</td>
                                <td>${numberFormat(p.undsDefectuosas)}</td>
                                <td>${formatText(p.nombreContaminacion)}</td>
                                <td>${numberFormat(p.undsContaminadas)}</td>
                                <td>${numberFormat(p.undsCalidad)}</td>
                                <td>${formatText(p.observaciones)}</td>
                            </tr>`).join('');
                }

                // ── Observaciones ────────────────────────────────────────────────
                if (!_obsUsuarioModificado) {
                    set('observacionesSoplado', txt(encabezado.observaciones));
                }
                const contObs = document.getElementById('contObservacionesSoplado');
                if (contObs) contObs.classList.toggle('canvaBloqueado', estado != 1);

                // ── Entrega ──────────────────────────────────────────────────────
                const contEntrega = document.getElementById('contEntregaSoplado');
                if (contEntrega) contEntrega.classList.toggle('canvaBloqueado', estado != 1);

                estado == 1 ? mostrar('btnAgregarAlmacenadoSoplado')
                            : ocultar('btnAgregarAlmacenadoSoplado');
                estado == 1 ? mostrar('btnAgregarEntregaLineaSoplado')
                            : ocultar('btnAgregarEntregaLineaSoplado');
                estado == 1 ? mostrar('btnAgregarConsumidoSoplado')
                            : ocultar('btnAgregarConsumidoSoplado');

                if (entrega) {
                    const unidadEmpaque = Number(entrega.unidadEmpaque) || 140;
                    window.unidadEmpaqueSoplado = unidadEmpaque;
                    const canvaEntrega = document.getElementById('canvaEntregaSoplado');
                    if (canvaEntrega) canvaEntrega.setAttribute('data-unidad-empaque', unidadEmpaque);
                    set('unidadEmpaqueSopladoTxt', num(unidadEmpaque));
                    set('unidadEmpaqueHeaderSoplado', `${num(encabezado.unidadEmpaque)} und`);
                    set('produccionNetaHeaderSoplado', `${num(entrega.producido)} und`);
                    set('cantPaquetesCreados',    numInput(entrega.numPaquetes));
                    set('saldoInicioTurnoSoplado', numInput(entrega.saldoInicioTurno));
                    set('saldoFinTurnoSoplado',    numInput(entrega.saldoFinTurno));
                    set('cantUnidadesCreados', `${num(entrega.undsPaquete)} und`);
                    set('bolsasSoplado',      numInput(entrega.undsTula));
                    set('retenidoSoplado',    numInput(entrega.retenido));
                    set('rechazadoSoplado',   numInput(entrega.rechazado));
                }

                // ── Tablas de entrega ────────────────────────────────────────────
                const idRep = encabezado.idReporteSoplado;
                if (typeof window.actualizarTablaEntregaLinea === 'function') window.actualizarTablaEntregaLinea(idRep);
                if (typeof window.actualizarTablaAlmacenado   === 'function') window.actualizarTablaAlmacenado(idRep);
                if (typeof window.actualizarTablaConsumido     === 'function') window.actualizarTablaConsumido(idRep);
                if (typeof window.actualizarBalanceSoplado     === 'function') window.actualizarBalanceSoplado(idRep);

                // ── Perfiles de operación ────────────────────────────────────────
                if (typeof window.poblarPerfilesSoplado === 'function') {
                    window.poblarPerfilesSoplado(perfilOperativo);
                }
                if (typeof window.bloquearPerfilesSoplado === 'function') {
                    window.bloquearPerfilesSoplado(estado != 1);
                }

                // ── Botón guardar ────────────────────────────────────────────────
                estado == 1 ? mostrar('contBtnGuardarSoplado')
                            : ocultar('contBtnGuardarSoplado');

                // ── Restaurar pestaña activa ─────────────────────────────────────
                modal.querySelectorAll('[data-etiqueda]').forEach(btn => btn.classList.remove('etiquetaSelect'));
                modal.querySelectorAll('.canvaMultiEtiqueta > [id^="canva"]').forEach(c => c.classList.add('oculto'));

                const btnParaActivar = modal.querySelector(`[data-etiqueda="${idEtiquetaGuardada}"]`);
                if (btnParaActivar) {
                    btnParaActivar.classList.add('etiquetaSelect');
                    const idCanva = 'canva' + idEtiquetaGuardada.charAt(0).toUpperCase() + idEtiquetaGuardada.slice(1);
                    const seccionActiva = modal.querySelector('#' + idCanva);
                    if (seccionActiva) seccionActiva.classList.remove('oculto');
                } else {
                    modal.querySelector('#canvaCabecera').classList.remove('oculto');
                    modal.querySelector('[data-etiqueda="cabecera"]').classList.add('etiquetaSelect');
                }
            })
            .catch(error => {
                console.error("Error en la solicitud:", error);
                alert("Ocurrio un error en reporte soplado, contactar al administrador.");
            });
    };


    // ─── Listener: abrir modal ────────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        const target = e.target.closest('.btnVerReporte');
        if (target && target.getAttribute('data-modal') === 'modalProduccionSoplado') {
            const idReporte = target.getAttribute('data-id');
            const modalElemento = document.querySelector("#modalProduccionSoplado");
            if (idReporte && modalElemento && typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
        }
    });

    // ─── Listener: reactivar reporte ─────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        const target = e.target.closest('#btnReactivarReporteSoplado');
        if (!target) return;

        const idReporte = target.getAttribute('data-id');
        if (!idReporte) return;
        if (!confirm('¿Deseas reactivar este reporte de turno?')) return;

        target.disabled = true;
        const spinner = target.querySelector('.spinner');
        if (spinner) spinner.classList.add('spinner--active');

        fetch('/api/soplado/reactivar-reporte', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `idEncabezadoReporteSoplado=${idReporte}`
        })
        .then(function(res) { return res.json(); })
        .then(function(result) {
            if (result.result.hayErrores) {
                const mensaje = result.result.errores && result.result.errores[0]
                    ? result.result.errores[0].mensaje
                    : 'Error al reactivar el reporte.';
                alert(mensaje);
                return;
            }
            window.actualizarModalReporteSoplado(idReporte);
            const params = new URLSearchParams(window.location.search);
            if (typeof window.actualizarTablaSopladoPeriodo === 'function') {
                window.actualizarTablaSopladoPeriodo(params.get('mes'), params.get('año'));
            }
        })
        .catch(function() { alert('Error al conectar con el servidor.'); })
        .finally(function() {
            target.disabled = false;
            if (spinner) spinner.classList.remove('spinner--active');
        });
    });

    // ─── Listener: eliminar reporte ──────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        const target = e.target.closest('#btnEliminarReporteSoplado');
        if (!target) return;

        const idReporte = target.getAttribute('data-id');
        const tieneRegistros = target.getAttribute('data-tiene-registros') === '1';

        if (tieneRegistros) {
            alert('No se puede eliminar el reporte porque tiene registros asociados (producción, PNC, tiempos muertos o lotes).');
            return;
        }
        if (!confirm('¿Estás seguro de que deseas eliminar este reporte? Esta acción no se puede deshacer.')) return;

        target.disabled = true;
        const spinner = target.querySelector('.spinner');
        if (spinner) spinner.classList.add('spinner--active');

        fetch('/api/soplado/eliminar-reporte', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `idEncabezadoReporteSoplado=${idReporte}`
        })
        .then(function(res) { return res.json(); })
        .then(function(result) {
            if (result.result.hayErrores) {
                const mensaje = result.result.errores && result.result.errores[0]
                    ? result.result.errores[0].mensaje
                    : 'Error al eliminar el reporte.';
                alert(mensaje);
                return;
            }
            const modal = document.querySelector('#modalProduccionSoplado');
            if (modal) {
                modal.querySelectorAll('form').forEach(function(f) { f.reset(); });
                modal.classList.remove('modal--show');
            }
            const params = new URLSearchParams(window.location.search);
            if (typeof window.actualizarTablaSopladoPeriodo === 'function') {
                window.actualizarTablaSopladoPeriodo(params.get('mes'), params.get('año'));
            }
        })
        .catch(function() { alert('Error al conectar con el servidor.'); })
        .finally(function() {
            target.disabled = false;
            if (spinner) spinner.classList.remove('spinner--active');
        });
    });
}
